import angular from 'angular';

(function() {
    'use strict';

    angular.module('dashboard').controller('DepositorDetailsCtrl', DepositorDetailsCtrl);

    DepositorDetailsCtrl.$inject = [
        '$scope',
        '$uibModal',
        '$state',
        '$transition$',
        'toastr',
        'DepositorService',
        'depositor'
    ];

    function DepositorDetailsCtrl($scope, $uibModal, $state, $transition$, toastr, DepositorService, depositor) {
        $scope.depositor = depositor;

        $scope.includes = {
            formMessages: require('../../../common/form-messages.html')
        };

        $scope.back = function() {
            $state.go('depositors', { keepFilter: true, tabName: $transition$.params().tabName });
        };

        $scope.showPopup = function() {
            $scope.isSubmit = true;
            if ($scope.form.$valid) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: require('./depositor-confirm-popup.html'),
                    controller: 'DepositorConfirmModalCtrl'
                });
                modalInstance.result.then(function(motif) {
                    if (motif) {
                        $scope.depositor.motif = motif;
                        DepositorService.updateDepositor($scope.depositor).$promise.then(
                            function(/*data*/) {
                                $state.go('depositors');
                            },
                            function(error) {
                                toastr.error('Impossible de sauvegarder le déposant', error);
                            }
                        );
                    }
                });
            }
        };
    }
})();
